import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import DataTable from "examples/Tables/DataTable";

function AgentsTableData({ data, onEdit, onDelete }) {
  const columns = [
    { Header: "SC Code", accessor: "sc_code", align: "left" },
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Phone", accessor: "phone", align: "left" },
    { Header: "Email", accessor: "email", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Action", accessor: "action", align: "center" },
  ];

  const rows = (data || []).map((a) => ({
    sc_code: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {a.sc_code}
      </MDTypography>
    ),
    name: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.name}
      </MDTypography>
    ),
    phone: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.phone || "—"}
      </MDTypography>
    ),
    email: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.email || "—"}
      </MDTypography>
    ),
    status: (
      <MDTypography
        variant="caption"
        color={a.status === "ACTIVE" ? "success" : "error"}
        fontWeight="medium"
      >
        {a.status}
      </MDTypography>
    ),
    action: (
      <div>
        <IconButton size="small" onClick={() => onEdit(a)}>
          <Icon fontSize="small">edit</Icon>
        </IconButton>
        <IconButton size="small" color="error" onClick={() => onDelete(a)}>
          <Icon fontSize="small">delete</Icon>
        </IconButton>
      </div>
    ),
  }));

  return (
    <DataTable
      table={{ columns, rows }}
      isSorted
      entriesPerPage={false}
      showTotalEntries={false}
      noEndBorder
      canSearch={false}
      size="small"
    />
  );
}

AgentsTableData.propTypes = {
  data: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default AgentsTableData;
